import React, {useState, useEffect} from "react";
import {Button, Card, Col, Modal, notification, Popconfirm, Row, Spin} from "antd";
import '../../../components/modals/modals.css';
import ModalCreateOrderDocs from "../create-order-docs";
import {carrierService, deliveriesService} from "../../../services";
import ModalEdoSend from "../edo-send";
import { edoService } from "../../../services/edo.services";
import i18n from '../../../i18n';


export default function ModalShowOrderDocs({isShow, onCloseModal, id}) {

  const [loadingContentModal, setLoadingContentModal] = useState(false);
  const [showEdoModal, setShowEdoModal] = useState(false);
  const [currentLegalEntityId, setCurrentLegalEntityId] = useState(false);
  const [currentType, setCurrentType] = useState(null);

  const [data, setData] = useState({
    invoice: null,
    act: null,
    id: null,
    num: null,
    legalEntityId: null,
  });

  const [isModalOrderDocsCreateShow, setIsModalOrderDocsCreateShow] = useState(false);

  const bigButtonStyle = {
    width: '100%',
    minHeight: '40px',
    background: '#1CAA53',
    borderRadius: '10px',
    borderColor: "#1CAA53"
  };
  const imgStyle = {
    width: "115px",
    height: "auto",
    border: "1px solid #1CAA53",
    borderRadius: "10px",
    display: "block",
    padding: "5px",
    margin: "15px auto"
  }

  const handleShowSend = (id, type) => {
    setCurrentLegalEntityId(id);
    setCurrentType(type);
    setShowEdoModal(true);
  };

  useEffect(() => {
    if (loadingContentModal) {
      deliveriesService.getInfoDelivery(id)
        .then((res) => {
          setData({
            invoice: res.Order.Docs.Invoice ? res.Order.Docs.Invoice : null,
            act: res.Order.Docs.Act ? res.Order.Docs.Act : null,
            id: res.Order.Id,
            num: res.NumberDelivery,
            legalEntityId: res.Order.Company.LegalEntityId,
          });
          setLoadingContentModal(false);
        })
        .catch((error) => {
          setLoadingContentModal(false);
          notification.error({
            message: i18n.t('components.notification.titles.getInfoDelivery'), description: error,
          });
        });
    }
  }, [loadingContentModal]);

  useEffect(() => {
    if (isShow && !loadingContentModal) {
      setLoadingContentModal(true);
    }
  }, [isShow]);

  return (
    <>
    <Modal
      title={i18n.t('modals.modalShowOrderDocs.title', {num:data.num ? data.num : ''})}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={onCloseModal}
      footer={<Popconfirm
        title={i18n.t('main.confirm.questions')}
        okText={i18n.t('main.confirm.answer.yes')}
        cancelText={i18n.t('main.confirm.answer.no')}
        onConfirm={() => setIsModalOrderDocsCreateShow(true)}
      >
        <Button type="primary"
                style={bigButtonStyle}
                icon={data.invoice || data.act ? `retweet` : `plus`}>
          {data.invoice || data.act ? i18n.t('modals.modalShowOrderDocs.buttons.recreate') : i18n.t('main.buttons.create')}
        </Button>
      </Popconfirm>}
    >
      <Spin spinning={loadingContentModal} tip={i18n.t('main.loadText.loading')}>
        <Row gutter={8} type={"flex"}>
          <Col md={24} lg={12}>
            <Card title={"Счет"} size={"large"} style={{textAlign: "center", fontWeight: "bold"}}>
              {
                data.invoice &&
                <>
                <a download href={data.invoice} target='_blank'>
                  <img
                    src={data.invoice.substring(data.invoice.length - 4, data.invoice.length) === '.pdf' ? 'https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg' : data.invoice}
                    alt="img" style={imgStyle}></img>
                </a>
                <Button style={{ marginLeft: "0px", width: "100%" }} onClick={() => handleShowSend(data.legalEntityId, 'invoice')} size="small" className="small-button typical-btn-green">
                    Отправить в ЭДО
                </Button>
                </>
              }
              {
                !data.invoice &&
                <p style={{textAlign: "center"}}>{i18n.t('modals.modalShowOrderDocs.fields.status.title')}</p>
              }
            </Card>
          </Col>
          <Col md={24} lg={12}>
            <Card title={"Акт"} size={"large"} style={{textAlign: "center", fontWeight: "bold"}}>
              {
                data.act &&
                <>
                <a download href={data.act} target='_blank'>
                  <img
                    src={data.act.substring(data.act.length - 4, data.act.length) === '.pdf' ? 'https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg' : data.act}
                    alt="img" style={imgStyle}></img>
                </a>
                <Button style={{ marginLeft: "0px", width: "100%" }} onClick={() => handleShowSend(data.legalEntityId, 'act')} size="small" className="small-button typical-btn-green">
                    Отправить в ЭДО
                </Button>
                </>
              }
              {
                !data.act &&
                <p style={{textAlign: "center"}}>{i18n.t('modals.modalShowOrderDocs.fields.status.title')}</p>
              }
            </Card>
          </Col>
        </Row>
        {data && <ModalCreateOrderDocs id={data.id}
                                       num={data.num}
                                       isShow={isModalOrderDocsCreateShow}
                                       onCloseModal={() => {
                                         setIsModalOrderDocsCreateShow(false);
                                         setLoadingContentModal(true);
                                       }}/>}
      </Spin>
    </Modal>
    <ModalEdoSend legalEntityId={currentLegalEntityId} isShow={showEdoModal} setIsShow={setShowEdoModal} type={currentType} orderId={data.id}/>
    </>
  );
}
